// ClickForest custom: klik op maat-chip op productkaart
// Stuurt door naar juiste variant op de productpagina via ?variant=ID
document.addEventListener('click', function (event) {
  const btn = event.target.closest('.product-card__size-chip');
  if (!btn) return;

  // Geen actie voor uitverkochte varianten
  if (btn.classList.contains('product-card__size-chip--sold-out')) return;

  const card = btn.closest('.product-card');
  const link = card && card.querySelector('a.product-card__media');
  const variantId = btn.getAttribute('data-variant-id');
  if (!link || !variantId) return;

  const url = new URL(link.href, window.location.origin);
  url.searchParams.set('variant', variantId);

  window.location.href = url.toString();
});
